<form [formGroup]="dataForm" class="without-default-focus">
    <div class="form-item form-item-help">
        <mat-form-field class="with-info-icon">
            <mat-label>Minuteur</mat-label>
            <mat-select data-select-configurationApiId formControlName="WorkflowTriggerName" required tabindex="10">
                @for (item of _timerTriggers; track item) {
                    <mat-option data-select-listing-type-option [value]="item.id">
                        {{ item.id }}
                    </mat-option>
                }
            </mat-select>
            @if (
                dataForm.controls['WorkflowTriggerName']?.errors?.required && (dataForm.controls['WorkflowTriggerName']?.dirty || dataForm.controls['WorkflowTriggerName'].touched)
            ) {
                <mat-error data-input-role-error>Le champ 'trigger' est obligatoire</mat-error>
            }
        </mat-form-field>
        <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO trigger de type minuteur" matTooltipPosition="right"></fa-icon>
    </div>
</form>
